import { useEffect, useState } from "react"
import { Clock, Shield, Tag, X } from "react-feather"

const supportEmail = "milsoconnect1@gmail.com"

export const WebinarDetailsModal = ({ video, onClose }) => {
    const [isAgreed, setIsAgreed] = useState(false)

    useEffect(() => {
        if (!video) {
            setIsAgreed(false)
            return undefined
        }

        const previousOverflow = document.body.style.overflow
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose()
            }
        }

        document.body.style.overflow = "hidden"
        document.addEventListener("keydown", handleKeyDown)

        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [video, onClose])

    if (!video) return null

    // Map API response fields (titleName, subTitleName, description, duration, price, poster, keyTopics)
    const title = video.titleName ? video.titleName : ""
    const subTitle = video.subTitleName ? video.subTitleName : ""
    const description = video.description ? video.description : ""
    const duration = video.duration ? video.duration : ""
    const price = video.video_PurchaseAmount || "0"
    const posterImage = video.thumbnailUrl || video.thumbnailPath || video.thumbnail || ""
    const keyTopics = video.keyTopics || video.keyPoints || video.KeyTopics || video.KeyPoints || ""
    const webinar = video
    const hasKeyTopics = Boolean((webinar?.keyTopics || keyTopics) && String(webinar?.keyTopics || keyTopics).trim())

    const subject = encodeURIComponent(`Webinar access purchase: ${title}`)
    const body = encodeURIComponent(
        `Hello MILSO Team,\n\nI would like to purchase access to the recorded webinar:\nTitle: ${title}\nWebinar ID: ${video.webinarVideoID || ""}\nPrice: ₹${price}\n\nThank you.`
    )

    const handlePurchase = () => {
        if (!isAgreed) return
        window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`
    }

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            style={{ backgroundColor: "rgba(8, 26, 39, 0.85)", zIndex: 100005 }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-xl"
                role="document"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: "980px", width: "95%" }}
            >
                <div
                    className="modal-content border-0 rounded-4 shadow-lg overflow-hidden position-relative"
                    style={{
                        borderRadius: "12px",
                        maxHeight: "88vh",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "#ffffff",
                    }}
                >
                    {/* Top Header Bar matching Video Popup */}
                    <div
                        className="d-flex align-items-center justify-content-between px-3 py-2 text-white"
                        style={{
                            backgroundColor: "#102b3c",
                            borderTopLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                            flexShrink: 0,
                        }}
                    >
                        <span className="fw-normal" style={{ fontSize: "16px", color: "#fff" }}>
                            Milso Insurance Learning and Sharing Online
                        </span>
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-sm text-white p-0 d-flex align-items-center justify-content-center"
                            style={{
                                width: "28px",
                                height: "28px",
                                border: "1px solid rgba(255,255,255,0.3)",
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                                lineHeight: 1,
                            }}
                            aria-label="Close"
                        >
                            <X size={16} />
                        </button>
                    </div>

                    <div className="modal-body p-0" style={{ overflow: "hidden", display: "flex", flex: 1, minHeight: 0 }}>
                        <div className="row g-0 w-100 flex-column flex-md-row" style={{ minHeight: 0 }}>
                            {/* Left Column: Poster Image */}
                            <div
                                className="col-12 col-md-5 d-flex align-items-center justify-content-center overflow-hidden position-relative"
                                style={{ backgroundColor: "#0c2b42", minHeight: "220px" }}
                            >
                                <img
                                    src={posterImage}
                                    alt={`MILSO Academy webinar - ${title}`}
                                    className="img-fluid w-100 h-100"
                                    style={{ objectFit: "contain", maxHeight: "calc(88vh - 48px)" }}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null
                                        e.currentTarget.src = "/Static/Assets/Img/Webinars/seminarimage.jpeg"
                                    }}
                                />
                            </div>

                            {/* Right Column: Details & Purchase */}
                            <div
                                className="col-12 col-md-7 p-3 p-md-4 d-flex flex-column justify-content-between"
                                style={{ overflowY: "auto", maxHeight: "calc(88vh - 48px)" }}
                            >
                                <div>
                                    {/* Eyebrow */}
                                    <p
                                        className="fw-bold text-uppercase mb-1"
                                        style={{ color: "#cd9e53", fontSize: "11.5px", letterSpacing: "0.1em" }}
                                    >
                                        MILSO ACADEMY WEBINAR
                                    </p>

                                    {/* Title */}
                                    <h2 className="fw-bold mb-2" style={{ color: "#16374e", fontSize: "24px" }}>
                                        {title}
                                    </h2>

                                    {/* Subtitle / Intro */}
                                    <p className="text-muted small mb-3" style={{ lineHeight: "1.5" }}>
                                        {subTitle}
                                    </p>
                                    {/* Meta Badges (Duration & Price) */}
                                    <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                        <span
                                            className="badge bg-light text-secondary border px-3 py-2 fw-normal d-inline-flex align-items-center rounded-3"
                                            style={{ fontSize: "13px" }}
                                        >
                                            <Clock size={15} className="me-2" style={{ color: "#16374e" }} />
                                            <span>Duration:</span>
                                            <strong className="ms-1" style={{ color: "#16374e" }}>
                                                {duration}
                                            </strong>
                                        </span>

                                        <span
                                            className="badge bg-light text-secondary border px-3 py-2 fw-normal d-inline-flex align-items-center rounded-3"
                                            style={{ fontSize: "13px" }}
                                        >
                                            <Tag size={15} className="me-2" style={{ color: "#16374e" }} />
                                            <span>Price:</span>
                                            <strong className="ms-1" style={{ color: "#16374e" }}>
                                                ₹{price}
                                            </strong>
                                        </span>
                                    </div>

                                    {/* Product Description */}
                                    <div className="mb-3">
                                        <h5
                                            className="fw-bold mb-1"
                                            style={{ color: "#16374e", fontSize: "15px" }}
                                        >
                                            Product Description
                                        </h5>
                                        <p
                                            className="text-secondary small mb-0"
                                            style={{ lineHeight: "1.6", textAlign: "justify" }}
                                        >
                                            {description}
                                        </p>
                                    </div>

                                    {/* Key Topics */}
                                    {hasKeyTopics && (
                                        <div className="mt-2 pt-2 border-top border-light mb-2">
                                            <strong className="d-block mb-1 text-dark" style={{ fontSize: "13px" }}>
                                                Key Topics:
                                            </strong>
                                            <p
                                                className="small text-muted mb-0"
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    whiteSpace: "pre-line",
                                                    lineHeight: "1.4",
                                                }}
                                            >
                                                {(webinar.keyTopics || keyTopics || "").replace(/<[^>]+>/g, " ").trim()}
                                            </p>
                                        </div>
                                    )}



                                    {/* Disclaimer Box */}
                                    <div
                                        className="p-3 rounded-3 mb-3"
                                        style={{
                                            backgroundColor: "#fdfbf7",
                                            border: "1px solid #ecdab9",
                                        }}
                                    >
                                        <div
                                            className="d-flex align-items-center mb-2 fw-bold"
                                            style={{ color: "#16374e", fontSize: "13.5px", letterSpacing: "0.05em" }}
                                        >
                                            <Shield size={16} className="me-2" style={{ color: "#c88b39" }} />
                                            <span>DISCLAIMER</span>
                                        </div>
                                        <div
                                            className="overflow-auto text-secondary pe-1"
                                            style={{
                                                maxHeight: "120px",
                                                fontSize: "11px",
                                                lineHeight: "1.55",
                                                textAlign: "justify",
                                            }}
                                        >
                                            <p className="mb-2">
                                                The sharing of these seminar/workshop/podcast and other recordings on the various topics of Marine Insurance is with the sole aim of demystifying these topics for the various stakeholders of the maritime Industry in India and also to raise awareness of challenges and concerns about the Marine Hull, Cargo, Labilities and Energy insurance.
                                            </p>
                                            <p className="mb-2">
                                                The issues discussed in the presentations have been prepared with care. Neither the facilitator nor the organizers can grantee that they are free from errors, and that they content every pertinent point. Reliance should only be placed upon them after an independent verification.
                                            </p>
                                            <p className="mb-2">
                                                The Facilitators and Organizers, Jointly and severally disclaim all liabilities for any loss whatsoever nature and howsoever arising as a result of acting or failing to act, by relying on the contents of this presentation.
                                            </p>
                                            <p className="mb-0">
                                                The views expressed by the facilitators do not necessarily reflects the views of the Organizers. The sole purpose of the presentations is for the academic and professional development only. Contents reflect the individual experts’ views and are not the legal advice, underwriting guidance or claim guidelines. Case studies and examples are illustrative and may not present actual real world complexities. Participants should seek independent professional advice before applying concepts discussed therein. MILSO and Facilitators assume no liability for actions taken based on seminar/webinar/Podcast/Lecturers contents or discussions. All materials are copyrighted; redistribution requires prior consent by MILSO.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Agreement Checkbox */}
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input mt-1"
                                            type="checkbox"
                                            id="webinarAgreeCheck"
                                            checked={isAgreed}
                                            onChange={(e) => setIsAgreed(e.target.checked)}
                                            style={{ cursor: "pointer", accentColor: "#16374e" }}
                                        />
                                        <label
                                            className="form-check-label user-select-none small ps-1"
                                            htmlFor="webinarAgreeCheck"
                                            style={{ color: "#16374e", cursor: "pointer", fontSize: "12px", lineHeight: "1.45" }}
                                        >
                                            I have read and agree to the product description, disclaimer, and applicable purchase terms.
                                        </label>
                                    </div>
                                </div>

                                {/* Purchase Now Button */}
                                <button
                                    type="button"
                                    className="btn w-100 fw-bold py-2 text-white shadow-sm rounded-3 mt-2"
                                    disabled={!isAgreed}
                                    onClick={handlePurchase}
                                    style={{
                                        backgroundColor: isAgreed ? "#cd9e53" : "#deb87b",
                                        borderColor: "#cd9e53",
                                        fontSize: "15px",
                                        cursor: isAgreed ? "pointer" : "not-allowed",
                                        transition: "all 0.2s ease",
                                    }}
                                >
                                    Purchase Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
